// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/components/common/footer.css
// module id = 787
// module chunks = 1